export function isDigitalProduct(product: { productType: string }): boolean {
  // `digitalCard` = premium digital. `basicDigitalV2` = the free Basic Digital V2
  // product, a real `stationeryProduct` the backend returns. `digital` = the legacy
  // free ecard, still a client-side synthetic (see `freeDigitalProduct`). All three
  // are digital.
  return product.productType === 'digitalCard' || product.productType === 'digital' || product.productType === 'basicDigitalV2';
}
